import {CITY_FIND_ALL} from "../utils/Constant";

const cities = function (state = {}, action) {
  switch (action.type) {
    case CITY_FIND_ALL:

      return state;
    default :
      return state;
  }
}
export default cities;
